export const error = {
  required: '必須です',
  below7: '7文字以内で入力してください',
  below20: '20文字以内で入力してください',
  below50: '50文字以内で入力してください',
  below250: '250文字以内で入力してください',
  below2000: '2000文字以内で入力してください',
  below5000: '5000文字以内で入力してください',
  number: '数字を入力してください',
  email: 'メールアドレス形式で入力してください',
  invalidFileType: 'PDF、PNG、JPG、JPEGのファイルを選択してください',
  maxFiles: '一度にアップロードできるファイルは最大30ファイルです',
  classificationMaxFiles: '一度にアップロードできるファイルは最大30ファイルです',
  maxSize: 'ファイルサイズの上限は10MBです',
  min: '6文字以上を入力してください',
  mixed: 'パスワードは英字と数字を必ず含め、記号も使用可能です。',
  image: '対応していない画像形式です',
  imageSize: '画像は10MBまでしか登録できません',
  passwordMatch: 'パスワードが一致しません',
  date: '日付形式で入力してください',
  csvMaxSize: 'ファイルサイズの上限は20MBです',
  masterCsvMaxSize: 'ファイルサイズの上限は350MBです',
  invalidCsvType: 'CSV形式のファイルを選択してください',
  // 拡張子が大文字（.CSV 等）のとき専用に表示する（#3050）。
  uppercaseCsvExtension: '拡張子は小文字の .csv にしてください',
  invalidEncoding: 'UTF-8 のファイルを選択してください。',
  tel: '数値とハイフンのみ入力可能です',
  agreeToTerms: '利用規約とプライバシーポリシーに同意してください',
};
